<template>
  <base-wrapper>
    <div class="grid grid-cols-1 gap-4">
      <base-card title="Import Cashbill">
        <div class="grid grid-cols-1 gap-4">
          <base-input
            label="File Cashbill"
            type="file"
            :shadow="false"
            size="padding-md"
            fullwidth
            accept=".csv"
            @change="onChangeCashbillFile"
          />
          <base-input
            label="File Cashbill Detail"
            type="file"
            :shadow="false"
            size="padding-md"
            fullwidth
            accept=".csv"
            @change="onChangeCashbillDetailFile"
          />
          <div class="col-span-full flex items-center gap-2">
            <base-button :loading="processLoading" @click="onProcess">{{
              processStatusMessage
            }}</base-button>
          </div>
        </div>
      </base-card>
      <base-card title="Keterangan">
        <dl class="grid gap-4">
          <div class="w-full">
            <dt class="text-sm text-gray-900">Contoh file import cashbill</dt>
            <dd class="mt-1 flex gap-2">
              <a
                href="/tool-bonus-import-example/cashbill.csv"
                class="text-sm font-medium text-green-600"
                >cashbill.csv</a
              >
              <a
                href="/tool-bonus-import-example/cashbill-detail.csv"
                class="text-sm font-medium text-green-600"
                >cashbill-detail.csv</a
              >
            </dd>
          </div>
        </dl>
      </base-card>
      <base-card title="Riwayat Import Cashbill">
        <datatable
          :total="histories.meta.page.total"
          :perPage="histories.meta.page.perPage"
          :currentPage="histories.meta.page.currentPage"
          @pagechanged="onChangePageHistories"
          :columns="[
            { id: 'date', name: 'Tanggal' },
            { id: 'finish_date', name: 'Selesai' },
            { id: 'user', name: 'User' },
            { id: 'status', name: 'Status', theadClass: 'text-center' },
            { id: 'error_file', name: 'Error File' },
          ]"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="history in histories.data"
              :key="history.id"
              :class="classes.tr"
            >
              <td :class="classes.td">
                {{ history.attributes.createdAt | formatDate }}
              </td>
              <td :class="classes.td">
                {{ history.attributes.finishedAt | formatDate }}
              </td>
              <td :class="classes.td">
                {{ history.attributes.user_email || '-' }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  :color="
                    history.attributes.status !== 'finished'
                      ? 'yellow'
                      : 'green'
                  "
                  >{{
                    processStatusMessageList[history.attributes.status]
                  }}</base-badge
                >
              </td>
              <td :class="classes.td">
                <a
                  v-if="history.attributes.status === 'finished'"
                  :href="history.attributes.error_file_url"
                  class="font-semibold text-green-600"
                  >Download</a
                >
              </td>
            </tr>
          </template>
        </datatable>
      </base-card>
    </div>
    <base-confirm
      message="Apakah anda yakin akan menambahkan cashbill yang diupload?"
      :visible="confirming"
      @close="confirming = false"
      @confirmed="onConfirmed"
    ></base-confirm>
    <loading v-if="historiesLoading" />
  </base-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { requestMixin } from '@/mixins/request/request';
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { validateFileCsv } from '@/utils/misc';

export default {
  mixins: [requestMixin],
  components: { BaseConfirm },
  data() {
    return {
      processLoading: false,
      historiesLoading: false,
      confirming: false,
      processStatus: 'null',
      form: {
        cashbillFile: null,
        cashbillDetailFile: null,
      },
      channelName: null,
      histories: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    processStatusMessageList() {
      return {
        null: 'Proses',
        request: 'Mengirim ke Server',
        wait: 'Menunggu Diproses',
        queued: 'Menunggu Antrian',
        started: 'Mulai Diproses',
        'cashbill-imported': 'Menambahkan Cashbill',
        'cashill-detail-imported': 'Menambahkan Cashbill Detail',
        finished: 'Selesai',
      };
    },
    processStatusMessage() {
      return this.processStatusMessageList[this.processStatus];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    listenToEvent() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgressImport
      );
    },
    async loadHistories(params) {
      this.historiesLoading = true;

      const [res, err] = await this.request('/api/v1/import-cashbills', {
        params: {
          'page[size]': 5,
          sort: '-id',
          'fields[import-cashbills]':
            'createdAt,user_email,finishedAt,status,error_file_url',
          ...params,
        },
      });

      if (!err) {
        this.histories = res;

        const { running, status } = res.meta.import_status;

        if (running) {
          if (status !== 'error' && status !== 'finished') {
            this.setProcessStatus(status);
            this.startProcessLoading();
          }
        }
      }

      this.historiesLoading = false;
    },
    onProgressImport(e) {
      if (e.type === 'App\\Notifications\\ImportCashbillStatusUpdated') {
        if (e.status === 'finished') {
          this.setProcessStatus('null');
          this.stopProcessLoading();
          this.createAlert({
            data: 'Berhasil menambahkan cashbill',
            status: 'success',
          });
          this.loadHistories();
        } else {
          this.processStatus = e.status;
        }
      }
    },
    onChangeCashbillFile(e) {
      this.form.cashbillFile = e.target.files[0];
    },
    onChangeCashbillDetailFile(e) {
      this.form.cashbillDetailFile = e.target.files[0];
    },
    onChangePageHistories(page) {
      this.loadHistories({ 'page[number]': page });
    },
    async onProcess() {
      if (
        !validateFileCsv(this.form.cashbillFile) ||
        !validateFileCsv(this.form.cashbillDetailFile)
      ) {
        this.createAlert({
          data: 'File yang diupload harus bertipe csv',
          status: 'error',
        });
      } else {
        this.confirming = true;
      }
    },
    async onConfirmed() {
      this.confirming = false;

      this.setProcessStatus('request');
      this.startProcessLoading();

      const formData = new FormData();

      formData.append('cashbill_file', this.form.cashbillFile);
      formData.append('cashbill_detail_file', this.form.cashbillDetailFile);

      const [, error] = await this.request(
        '/api/v1/import-cashbills/-actions/import',
        {
          method: 'post',
          data: formData,
        }
      );

      if (error) {
        this.createAlert({
          data: this.getRequestErrorMessage(error),
          status: 'error',
        });
        this.setProcessStatus('null');
        this.stopProcessLoading();
      } else {
        this.setProcessStatus('wait');
      }
    },
    setProcessStatus(status) {
      this.processStatus = status;
    },
    startProcessLoading() {
      this.processLoading = true;
    },
    stopProcessLoading() {
      this.processLoading = false;
    },
    stopListenToEvent() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onProgressImport
        );
      }
    },
  },
  created() {
    this.listenToEvent();
    this.loadHistories();
  },
  destroyed() {
    this.stopListenToEvent();
  },
};
</script>
